import { Box, ThemeProvider, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import StyledBox from 'views/rebranded-module/common/components/UI/TourFootNote/TourFootNote.styles';
import theme from 'lib/config/theme';

const TourFootNote: FC<any> = (props) => {
  const { t } = useTranslation('common_tour_footnote');
  const { content = {}, className } = props;
  return (
    <ThemeProvider theme={theme}>
      <StyledBox className={className}>
        <Box className="TFNInfoContainer">
          <InfoOutlinedIcon className="TFNInfoIcon" />
        </Box>
        <Box p={2} className="TFNTextContainer">
          <Typography variant="body3">
            {content.footNoteText || t('common_tour_footnote:tax_disclamer')}
          </Typography>
        </Box>
      </StyledBox>
    </ThemeProvider>
  );
};

export { TourFootNote };
